<template>
  <div class="view home">
    <section class="banner">
      <div class="banner-background">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1900 1142"><defs><clipPath id="hb-a"><rect width="1900" height="1142" fill="#fff"/></clipPath><linearGradient id="hb-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="hb-d" x="-996.427" y="-1678.665" width="3024.699" height="3386.665" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="hb-f" x="877.5" y="687.5" width="73" height="73" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="g"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="hb-h" x="815.5" y="648.5" width="91" height="91" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="i"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="i"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#hb-a)"><path d="M1977.427,1116.172c1165.781,957.611,1148.792-250.375,1148.792,307.09s-711.452,947.233-1870.276,119.4S133.067,1553.6,133.067,996.131c0-453.773,533.073-700.764,1234.163-330.885,44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#hb-b)"/><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#hb-d)"><path d="M1735.8,68.8c801.071,1055.6,737.631,167.285,847.943,542.018s-598.555,1220.746-1468.318,577.127S0,1399.183,0,965.77,934.723-986.8,1735.8,68.8Z" transform="translate(1621.74 -890.92) rotate(118)" fill="url(#hb-b)"/></g></g><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#hb-f)"><circle cx="8" cy="8" r="8" transform="translate(906 704)" fill="#fff"/></g><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#hb-h)"><circle cx="17" cy="17" r="17" transform="translate(844 665)" fill="#00a1ed"/></g></svg> -->
        <img src="@/assets/cast_home_banner.svg">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="982" viewBox="0 0 1900 982"><defs><clipPath id="hb-a"><rect width="1900" height="982" fill="#fff" stroke="#707070" stroke-width="1"/></clipPath><linearGradient id="hb-b" x1="1" y1="-0.061" x2="0.153" y2="0.973" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.892" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></linearGradient><linearGradient id="hb-c" x1="0.275" y1="-0.12" x2="0.403" y2="0.837" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.861" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></linearGradient><linearGradient id="hb-d" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient></defs><g clip-path="url(#hb-a)"> -->
          <!-- <path pathmod="M76.684,4.982c37.937-2.708,82.629,18.727,82.629,64.566s-38.858,71.3-82.629,78.627S-6.59,129.762-6.59,83.922,38.746,7.691,76.684,4.982Z" d="M78.092,0C116.03-2.708,151.75,26.327,151.75,72.167s-37.286,79.172-81.057,86.5S0,128.84,0,83,40.155,2.708,78.092,0Z" transform="translate(319.256 771)" fill="url(#b)"/> -->
          <!-- <path pathmod="M23,6.62c12.116-.47,23.194,10.292,23.56,23.7S31.213,44.7,20.99,42.712,8.163,37.769,4.1,25.623,10.88,7.09,23,6.62Z" d="M24.986.714C37.1.243,48.762,9.04,49.128,22.449s-11.3,22.844-25.242,24.616S1.03,37.741.664,24.331,12.87,1.184,24.986.714Z" transform="translate(494.595 819.332) rotate(-121)" fill="#019edf"/> -->
          <!-- <path pathmod="M23,6.62c12.116-.47,23.194,10.292,23.56,23.7S31.213,44.7,20.99,42.712,8.163,37.769,4.1,25.623,10.88,7.09,23,6.62Z" d="M15.644.031C23.244-.449,30.4,4.7,30.4,12.829s-7.469,14.04-16.238,15.34S0,22.879,0,14.75,8.044.511,15.644.031Z" transform="translate(279.394 819.527) rotate(-90)" fill="#099aa8"/> -->
          <!-- <ellipse cx="6.586" cy="7" rx="6.586" ry="7" transform="translate(338.073 938)" fill="#0d988c"/> -->
          <!-- <path pathmod="M1977.427,1116.172c58.289,47.88,113.621,90.347,166.813,128.367l-195.187,483.1L151.275,1001.293,305.524,619.516C562.48,354.756,869.04,441.05,1330.359,684.43c44.894,29.435-28.3,88.714-4.155,107.371s101.053,7.433,173.375,17.351S1803.086,972.962,1977.427,1116.172Z" d="M1977.427,1116.172c58.289,47.88,113.621,90.347,166.813,128.367l-195.187,483.1L151.275,1001.293,305.524,619.516C517.34,445.569,905.912,421.866,1367.23,665.246c44.894,29.435-33.583,65.2-.347,90.884s53.651-7.522,125.973,2.4S1803.086,972.962,1977.427,1116.172Z" transform="translate(2429.218 840.273) rotate(158)" fill="url(#hb-c)"/>
          <path pathmod="M1644.947,78.713c310.813,409.573,582.332,516.59,693.827,528.23-255.287,144.478-819.865,472.223-819.865,472.223S1171.62,437.109,865.393-239.624C1140-357.8,1355.756-302.364,1644.947,78.713Z" d="M1735.8,68.8c310.814,409.572,491.483,526.5,602.978,538.141-255.287,144.478-819.865,472.223-819.865,472.223S1171.62,437.109,865.393-239.624C1140-357.8,1446.6-312.275,1735.8,68.8Z" transform="translate(1621.745 -890.917) rotate(118)" fill="url(#hb-d)"/></g></svg> -->
      </div>
      <div class="wrapper">
        <div class="introduction">
          <h1 class="title">Creative Accelerators <b>for Sustainable Tourism</b></h1>
          <p>Over 100 SMEs across Europe <b>will be supported by CAST</b></p>
        </div>
        <router-link v-if="nextEvent" :to="`/events/${nextEvent.id}`" class="next-event">
          <div class="event-title"><span>{{nextEvent.title}}&nbsp;<i class="fas fa-long-arrow-alt-right"></i></span></div>
          <div class="event-date"><span><span class="month"><DateFormat class="mobile" :date="nextEvent.date.toDate()" format="%Lm" /><DateFormat :date="nextEvent.date.toDate()" format="%lm" /></span>&nbsp;<DateFormat :date="nextEvent.date.toDate()" format="%d, %Y" /></span></div>
          <div class="event-location"><span>{{nextEvent.location}}</span></div>
        </router-link>
        <router-link v-else-if="events.length" :to="`/events/${events[0].id}`" class="next-event">
          <div class="event-title"><span>{{events[0].title}}&nbsp;<i class="fas fa-long-arrow-alt-right"></i></span></div>
          <div class="event-date"><span><span class="month"><DateFormat class="mobile" :date="events[0].date.toDate()" format="%Lm" /><DateFormat :date="events[0].date.toDate()" format="%lm" /></span>&nbsp;<DateFormat :date="events[0].date.toDate()" format="%d, %Y" /></span></div>
          <div class="event-location"><span>{{events[0].location}}</span></div>
        </router-link>
        <div class="follow">
          <div class="follow-image edge" v-if="!isMobile"></div>
          <svg v-if="!isMobile" class="follow-image not-edge" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="779.828" height="764.422" viewBox="0 0 779.828 764.422"><defs><filter id="hbp-a" x="693.981" y="159.423" width="85.847" height="85.847" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="hbp-c" x="481.9" y="48.401" width="79.291" height="79.291" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="hbp-e" x="522.98" y="138.359" width="100" height="100" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter><pattern id="hbp-g" width="1" height="1" viewBox="144.9 262.185 518.427 522.408" preserveAspectRatio="xMidYMid slice"><image width="663" height="884" :xlink:href="require('@/assets/shapes/home_banner_pic-image.jpg')"/></pattern><filter id="hbp-h" x="0" y="0" width="759.327" height="764.422" filterUnits="userSpaceOnUse"><feOffset dy="16" input="SourceAlpha"/><feGaussianBlur stdDeviation="16" result="i"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="i"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(-910.672 -170.141)"><g transform="translate(0 -100)"><g transform="matrix(1, 0, 0, 1, 910.67, 270.14)" filter="url(#hbp-a)"><circle cx="11" cy="11" r="11" transform="matrix(-0.39, -0.92, 0.92, -0.39, 731.08, 204.77)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 910.67, 270.14)" filter="url(#hbp-c)"><circle cx="8.5" cy="8.5" r="8.5" transform="matrix(-0.39, -0.92, 0.92, -0.39, 517.04, 87.19)" fill="#00a1ed"/></g><g transform="matrix(1, 0, 0, 1, 910.67, 270.14)" filter="url(#hbp-e)"><circle cx="21.5" cy="21.5" r="21.5" transform="translate(551.48 154.86)" fill="#00a1ed"/></g></g><g transform="matrix(1, 0, 0, 1, 910.67, 170.14)" filter="url(#hbp-h)"><path d="M331.664,65.307C446.6,262.937,663.328,151.788,663.328,334.961S514.837,666.625,331.664,666.625,0,518.134,0,334.961,216.731-132.323,331.664,65.307Z" transform="translate(48 33.8)" fill="url(#hbp-g)"/></g></g></svg>
          <div class="socials">
            <a href="https://twitter.com/CastnetworkE" target="_blank">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/showcase/cast-network-eu/about/" target="_blank">
              <i class="fab fa-linkedin"></i>
            </a>
            <div>Follow us</div>
          </div>
        </div>
      </div>
    </section>
    <section class="creative">
      <div class="wrapper">
        <div class="section-description">
          <h2>Creative Accelerators</h2>
          <p v-if="page" v-html="page.creative.replace(/\n/g, '<br>')"></p>
          <router-link to="/register" class="btn btn-ic green">
            <span>Register</span>
            <i class="btn-icon fas fa-long-arrow-alt-right"></i>
            <i class="line1"></i>
            <i class="line2"></i>
          </router-link>
        </div>
        <div class="creative-text" v-if="page" v-html="page.image_section1"></div>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1347.015" height="1110.979" viewBox="0 0 1347.015 1110.979"><defs><pattern id="axxx" width="100%" height="100%" viewBox="0 0 979 1469" preserveAspectRatio="xMidYMid slice"><image width="979" height="1469" :xlink:href="require('@/assets/shapes/home_creative-image.jpg')"/></pattern><pattern id="bxxx" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 1350 900"><image width="1350" height="900" :xlink:href="require('@/assets/shapes/home_creative-image2.jpg')"/></pattern><linearGradient id="cxxx" x1="0.868" y1="-0.698" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></linearGradient></defs><g transform="translate(-276.502 -1117.211)"><path d="M30.607-.106C45.476-1.168,59.476,10.212,59.476,28.179s-14.614,31.03-31.769,33.9S0,50.391,0,32.425,15.738.955,30.607-.106Z" transform="translate(1335.989 1297.851) rotate(90)" fill="#0d988c" opacity="0.23"/><path d="M15.944.012C23.885-.3,31.526,5.468,31.766,14.256s-7.4,14.971-16.543,16.132S.245,24.277.005,15.489,8,.32,15.944.012Z" transform="translate(1442.063 1339.957) rotate(-31)" fill="#0d988c" opacity="0.23"/><path d="M10.252.02c4.981-.315,9.67,3.06,9.67,8.387s-4.9,9.2-10.642,10.053S0,14.994,0,9.667,5.272.335,10.252.02Z" transform="translate(1402.332 1188.755)" fill="#0d988c" opacity="0.23"/><ellipse cx="4.316" cy="4.587" rx="4.316" ry="4.587" transform="translate(1304.691 1117.211) rotate(90)" fill="#0d988c" opacity="0.23"/><g transform="translate(0 107)"><path d="M-11440.367,1475.678c253.754-92.523,921.935-370.792,735.883-222.652s-983.635,483.11-1240.987,556.172S-11694.12,1568.2-11440.367,1475.678Z" transform="translate(12294.215 248.395)" fill="none" stroke="#0d988c" stroke-width="3" opacity="0.23"/><path d="M149.257,474.031C301.23,401.223,658.425,182.055,788.8,72.688s-87.985-59.955-274.5,59.329S-2.714,546.839,149.257,474.031Z" transform="translate(499.468 1662.281) rotate(-25)" fill="none" stroke="#0d988c" stroke-width="3" opacity="0.23"/><path d="M-12215.789,1430.609c-51.881-80.363,47.773-150.817,261.754-233.431s396.434-126.473,574.716-108.2,148.792,165.045,56.146,279.438-163.562,149.224-407.281,189.313S-12163.9,1510.972-12215.789,1430.609Z" transform="translate(12851.804 333.599)" fill="url(#axxx)"/><path d="M-11923.668,1429.464c-190.546-64.309-229.87-263.167-49.636-335.679s211.348-162.492,424-93.6,277.064,219.327,218.183,352.808S-11733.122,1493.773-11923.668,1429.464Z" transform="translate(12371.304 511.69)" fill="url(#bxxx)"/><path d="M440,1.617C643.186,7.685,807.026,122.38,811.152,252.5s-151.461,275.672-354.645,269.6S11.787,358.862-1.583,228.232,236.818-4.451,440,1.617Z" transform="translate(619.018 1427.473)" opacity="0.23" fill="url(#cxxx)"/><path d="M39.633,0c18.76,0,27.925,17.1,37.233,39.657s18.76,50.564,0,50.564S11.135,62.212,1.827,39.657,20.873,0,39.633,0Z" transform="translate(765.901 1880.262) rotate(-17)" fill="#0d988c" opacity="0.23"/><path d="M16.959,0A16.959,16.959,0,0,1,33.918,16.959c0,9.366-12.636,3.456-16.959,9.233S0,26.326,0,16.959A16.959,16.959,0,0,1,16.959,0Z" transform="translate(1293.574 1369.486)" fill="#0d988c" opacity="0.23"/><path d="M30.531,10.019c16.862,0,30.531,3.65,30.531,20.512A30.531,30.531,0,0,1,0,30.531C0,13.669,13.669,10.019,30.531,10.019Z" transform="translate(654.574 1994.486)" fill="#0d988c" opacity="0.23"/><path d="M7.819,0c4.318,0,11.215,4.791,11.215,9.109s-6.9,6.528-11.215,6.528A7.819,7.819,0,0,1,7.819,0Z" transform="matrix(-0.309, 0.951, -0.951, -0.309, 1386.053, 1338.696)" fill="#0d988c" opacity="0.23"/><path d="M7.819,0c4.318,0,11.215,4.791,11.215,9.109s-6.9,6.528-11.215,6.528A7.819,7.819,0,0,1,7.819,0Z" transform="translate(598.569 2058.595) rotate(-50)" fill="#0d988c" opacity="0.23"/></g><ellipse cx="4.316" cy="4.587" rx="4.316" ry="4.587" transform="matrix(0.259, -0.966, 0.966, 0.259, 617.572, 2225.815)" fill="#0d988c" opacity="0.23"/></g></svg>
    </section>
    <section class="news" v-if="posts.length">
      <div class="wrapper">
        <h2>News</h2>
        <div class="posts-mobile" v-if="isMobile">
          <swiper :options="{
            slidesPerView: elWidth > 600 && posts.length > 1 ? 2 : 'auto',
            spaceBetween: elWidth > 600 ? '-10%' : '-20%'
          }">
            <swiper-slide v-for="post in posts" :key="`m-${post.id}`">
              <NewsItem :post="post" />
            </swiper-slide>
          </swiper>
        </div>
        <div class="posts" v-else>
          <NewsItem :post="post" v-for="post in posts" :key="post.id" />
        </div>
        <router-link class="btn btn-ic" to="/news">
          <span>All news</span>
          <i class="btn-icon fas fa-long-arrow-alt-right"></i>
          <i class="line1"></i>
          <i class="line2"></i>
        </router-link>
      </div>
    </section>
    <section class="events" v-if="events.length">
      <div class="wrapper">
        <div class="title-line">
          <h2>What's on?</h2>
          <div class="subtitle">Discover all CAST events and workshops</div>
        </div>
        <div class="posts-mobile" v-if="isMobile">
          <swiper :options="{
            slidesPerView: elWidth > 600 && events.length > 1 ? 1.5 : 'auto',
            spaceBetween: elWidth > 600 ? '-9%' : '-18%',
          }">
            <swiper-slide v-for="event in events" :key="`m-${event.id}`">
              <EventItem :event="event" />
            </swiper-slide>
          </swiper>
        </div>
        <div class="posts" v-else>
          <EventItem :event="event" class="post" v-for="event in events" :key="event.id" />
        </div>
        <router-link class="btn btn-ic lime" to="/events">
          <span>All events</span>
          <i class="btn-icon fas fa-long-arrow-alt-right"></i>
          <i class="line1"></i>
          <i class="line2"></i>
        </router-link>
      </div>
    </section>
    <section class="innovation">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1183.544" height="636.148" viewBox="0 0 1183.544 636.148"><defs><linearGradient id="acc" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#e77323"/><stop offset="0.08" stop-color="#f77e0b"/><stop offset="0.499" stop-color="#76187e"/><stop offset="0.994" stop-color="#880f50"/></linearGradient><pattern id="bcc" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 1950 1300"><image width="1950" height="1300" :xlink:href="require('@/assets/shapes/home_innovation-image.jpg')"/></pattern><pattern id="ccc" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 1963 1287"><image width="1963" height="1287" :xlink:href="require('@/assets/shapes/home_innovation-image2.jpg')"/></pattern><linearGradient id="dcc" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><linearGradient id="ecc" xlink:href="#acc"/></defs><g transform="translate(-358.701 -4214.25)"><path d="M-11736.2,4285.808c-86.7,111.934-19.133,361.1,242.162,507.695,258.941,145.269,418.824-3.58,720.237-196.793s-174.929-211.562-459.529-299.313S-11649.494,4173.874-11736.2,4285.808Z" transform="translate(12219.668 -1.436)" opacity="0.08" fill="url(#acc)"/><path d="M12407.2,421.851c-182.244-61.508-292.057-272.078-213.407-362.771s324.611-65.887,528,0,230.648,198.354,152,289.046c-53.582,61.787-166.155,102.152-290.083,102.157C12525.727,450.286,12465.281,441.455,12407.2,421.851Zm452.523-315.025c-12.466-2.308-37.5-15.356-36.212-29.314s28.889-28.82,41.354-26.512,24.617,19.673,23.333,33.631c-1.165,12.659-13.388,22.514-24.954,22.513A19.35,19.35,0,0,1,12859.719,106.826Z" transform="translate(-11428.53 4278.271)" fill="url(#bcc)"/><path d="M12269.157,409.813c-199.912-26.541,134.824-383.37,341.916-406.124s101.141,63.95,237.765,143.657,121.063,113.841-23.2,179.309c-115.153,52.256-273.675,90.985-434.627,90.988A926.84,926.84,0,0,1,12269.157,409.813ZM12254.778,185c-9.868-1.828-29.686-12.156-28.669-23.207s22.871-22.816,32.739-20.991,19.492,15.578,18.476,26.625c-.926,10.024-10.6,17.825-19.756,17.824A15.326,15.326,0,0,1,12254.778,185Z" transform="translate(-11849.072 4323.159)" fill="url(#ccc)"/><path d="M-11671.292,5877.033c108.5-41.542,255.382,290.9,200.963,404.459s-364.558,121.816-418.637,49.8S-11779.789,5918.574-11671.292,5877.033Z" transform="translate(12599.154 -1622.213)" opacity="0.23" fill="url(#dcc)"/><path d="M-11663.895,5876.053c112.012-30.146,263.654,211.1,207.473,293.506s-376.366,88.4-432.2,36.135S-11775.905,5906.2-11663.895,5876.053Z" transform="matrix(-0.259, 0.966, -0.966, -0.259, 3749.617, 17406.77)" opacity="0.37" fill="url(#ecc)"/></g></svg>
      <div class="innovation-text" v-if="page" v-html="page.image_section2"></div>
    </section>
    <section class="partners" v-if="partners.length">
      <div class="wrapper">
        <div class="section-description">
          <h2>Featured Partners</h2>
          <p v-if="page" v-html="page.partners.replace(/\n/g, '<br>')"></p>
        </div>
        <div class="partners-list" v-if="isMobile">
          <swiper ref="partnersSwiper" :options="{
            slidesPerView: elWidth > 600 ? 2.5 : 1.55,
            spaceBetween: 32,
            centeredSlides: true,
          }">
            <swiper-slide v-for="partner in partners" :key="partner.id">
              <a :href="(partner.link.startsWith('http') ? '' : 'http://') + partner.link" target="_blank" class="partner">
                <img :src="partner.image" :alt="partner.name">
                <div class="link">Visit website <i class="ic ic-link"></i></div>
              </a>
            </swiper-slide>
          </swiper>
        </div>
        <div class="partners-list" v-else>
          <a :href="(partner.link.startsWith('http') ? '' : 'http://') + partner.link" target="_blank" class="partner" v-for="partner in partners" :key="partner.id">
            <img :src="partner.image" :alt="partner.name">
            <div class="link">Visit website <i class="ic ic-link"></i></div>
          </a>
        </div>
        <router-link to="/partners" class="btn btn-ic purple">
          <span>All partners</span>
          <i class="btn-icon fas fa-long-arrow-alt-right"></i>
          <i class="line1"></i>
          <i class="line2"></i>
        </router-link>
      </div>
    </section>
    <Newsletter />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import NewsItem from '../components/NewsItem'
import EventItem from '../components/EventItem'
import Newsletter from '../components/Newsletter'
import DateFormat from '../components/DateFormat'
// import anime from 'animejs'

export default {
  name: 'home',
  components: {
    Newsletter,
    NewsItem,
    EventItem,
    DateFormat,
  },
  computed: {
    ...mapGetters({
      db: 'getDb',
      isMobile: 'getMobile',
      elWidth: 'getWidth'
    }),
  },
  data() {
    return {
      partners: [],
      posts: [],
      events: [],
      nextEvent: null,
      page: null
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('homepage').onSnapshot(page => {
      this.page = page.data()
    })
    this.partnersRef = this.db().collection('partners').where('featured', '==', true).orderBy('order').onSnapshot(partners => {
      this.partners = partners.docs.map(doc => doc.data())
      this.preloadImages([
        require('@/assets/shapes/home_innovation-image.jpg'),
        require('@/assets/shapes/home_innovation-image2.jpg'),
        require('@/assets/shapes/home_creative-image.jpg'),
        require('@/assets/shapes/home_creative-image2.jpg'),
        require('@/assets/shapes/home_banner_pic-image.jpg')
      ])
      .then(() => {
        this.$store.commit('setPageLoading', false)
      })
      .catch(() => {
        this.$store.commit('setPageLoading', false)
      })
      if(this.isMobile) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
          this.$refs.partnersSwiper.update()
        }, 1000)
      }
    })
    this.newsRef = this.db().collection('posts').orderBy('date', 'desc').limit(3).onSnapshot(posts => {
      this.posts = posts.docs.map(doc => doc.data())
    })
    this.eventsRef = this.db().collection('events').orderBy('date', 'desc').limit(2).onSnapshot(events => {
      this.events = events.docs.map(doc => doc.data())
    })
    this.nextEventRef = this.db().collection('events').where('date', '>=', new Date()).orderBy('date').limit(1).onSnapshot(events => {
      this.nextEvent = events.size ? events.docs[0].data() : null
    })
    this.$nextTick(() => {
      this.$el.querySelectorAll('path[pathmod]').forEach(path => {
        const d = path.getAttribute('d')
        let mod = path.getAttribute('pathmod')
        if(d && mod) {
          // anime({
					// 	targets: path,
					// 	duration: anime.random(3000, 5000),
					// 	easing: 'easeInOutQuad',
					// 	d: mod,
					// 	loop: true,
					// 	direction: 'alternate'
					// })
        }
      })
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
    if(this.partnersRef) this.partnersRef()
    if(this.newsRef) this.newsRef()
    if(this.eventsRef) this.eventsRef()
    if(this.nextEventRef) this.nextEventRef()
  }
}
</script>

<style scoped>
.banner {
  position: relative;
  height: 100vh;
  min-height: 900px;
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
  will-change: transform;
}

.banner .banner-background svg,
.banner .banner-background img {
  display: block;
  width: 100%;
  height: auto;
}

.banner .wrapper {
  height: 100%;
  padding-top: 202px;
}

.banner .wrapper:before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 8px;
  width: 255px;
  height: 200px;
  background: url(../assets/cast_home_bubbles.svg) no-repeat center/contain;
}

.banner .introduction {
  position: absolute;
  top: 240px;
  left: 202px;
  color: #fff;
  width: 500px;
  max-width: 100%;
}

.banner .introduction:before {
  content: '';
  position: absolute;
  top: -20px;
  left: -62px;
  width: 135px;
  height: 142px;
  background: url(../assets/cast_home_shapes.svg) no-repeat center/contain;
}

.banner .introduction h1 {
  position: relative;
  font-weight: 400;
  font-size: 3.21em;
  line-height: 1.06;
}

.banner .introduction p {
  width: 358px;
  margin-top: 8px;
}

.banner .introduction p b {
  display: block;
}

.banner .next-event {
  position: absolute;
  left: 136px;
  bottom: 28px;
  width: 392px;
  height: 104px;
  border-radius: 52px;
  padding: 22px 24px 0 40px;
  background: #fff;
  box-shadow: 0 12px 25px rgba(0, 52, 77, .08);
  color: #00A1ED;
  line-height: 1;
  text-transform: uppercase;
  z-index: 4;
}

.banner .next-event i {
  font-size: 1.42rem;
  padding-right: 4px;
  margin-left: 8px;
  vertical-align: baseline;
}

.banner .next-event .event-title {
  position: relative;
  font-size: 1.1rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 36px;
  margin-bottom: 4px;
}

.banner .next-event .event-date {
  font-size: 1.28rem;
  font-weight: bold;
  letter-spacing: .2em;
}

.banner .next-event .event-date .mobile {
  display: none;
}

.banner .next-event .event-date .month {
  font-size: 1rem;
}

.banner .next-event .event-location {
  font-size: .72rem;
  letter-spacing: .58em;
  margin-top: 8px;
}

.banner .next-event > i,
.banner .next-event > div > span {
  display: inline-block;
  transition: transform .16s ease-out;
  will-change: transform;
}

@media screen and (min-width: 1025px) {
  .banner .next-event:hover > i,
  .banner .next-event:hover > div > span {
    transform: translateX(calc(321px - 100%));
  } 
}

.banner .follow {
  width: 52.3%;
  text-align: right;
  margin: 0 0 0 auto;
  color: #00A1ED;
  letter-spacing: .58em;
}

.banner .follow .follow-image {
  position: absolute;
  display: block;
  height: 80vh;
  min-height: 635px;
  max-width: 58%;
  bottom: 24px;
  right: -98px;
  pointer-events: none;
}

.banner .follow .follow-image.edge {
  width: 100%;
  background: url(../assets/cast_home_photo.png) no-repeat center right/contain;
}

.banner .follow .socials {
  position: absolute;
  bottom: 40px;
  right: 0;
}

.banner .follow .socials a {
  font-size: .85rem;
  margin-left: 16px;
}

.banner .follow .socials div {
  font-size: .72rem;
  text-transform: uppercase;
}

.section-description {
  width: 664px;
  max-width: 100%;
  text-align: left;
}

section h2 {
  font: bold 3.21em/1 'Butler';
}

section h2:after {
  content: '';
  display: block;
  width: 74px;
  height: 1px;
  background: currentColor;
  margin-top: 20px;
}

.section-description p {
  font-size: 1.42em;
  font-weight: 300;
  line-height: 2;
  margin: 20px 0 68px;
}

.creative {
  position: relative;
  margin-top: 156px;
  padding-top: 30px;
  /* height: 1300px; */
  /* background: url(../assets/cast_home_s_creative.jpg) no-repeat center/1344px auto; */
}

.creative > .wrapper {
  padding-bottom: 19%;
}

.creative h2 {
  color: #0D988C;
}

.creative svg {
  position: absolute;
  width: 1347px;
  height: auto;
  max-width: calc(100% - 48px);
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
}

.creative .creative-text,
.innovation .innovation-text {
  position: relative;
  width: 622px;
  font-size: 3.21em;
  line-height: 1.15;
  margin: 16% auto 0;
  color: #fff;
  text-shadow: 1px 1px 0 rgba(0,0,0,.46);
  z-index: 1;
}

.news {
  margin-top: 72px;
  text-align: center;
}

.news h2 {
  color: #F77E0B;
}

.news h2:after {
  margin-left: auto;
  margin-right: auto;
}

.news .wrapper {
  width: 1438px;
}

.posts {
  display: flex;
  justify-content: center;
  margin-bottom: 64px;
}

.posts .post {
  width: 33.333333%;
  text-align: center;
  margin-top: 80px;
}

.events {
  text-align: center;
  background: url(../assets/cast_home_s_events.png) no-repeat top left/28.65% auto;
  padding-top: 26px;
  margin-top: 140px;
}

.events .btn-ic {
  margin-left: 92px;
}

.events .wrapper {
  margin: 0 0 0 28.65%;
  width: auto;
  max-width: 1072px;
}

.events h2 {
  color: #8ABB2A;
}

.title-line {
  display: flex;
  align-items: center;
}

.title-line h2:after {
  display: inline-block;
  vertical-align: middle;
  margin: 0 36px;
}

.title-line .subtitle {
  font-size: .72em;
  letter-spacing: .58em;
  color: #8ABB2A;
  text-transform: uppercase;
}

.events .posts {
  margin-left: 92px;
}

.events .posts .post {
  width: 50%;
}

.innovation {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1184px;
  height: 636px;
  /* background: url(../assets/cast_home_s_innovation.png) no-repeat center/contain; */
  margin: 68px auto 0;
  max-width: calc(100% - 48px);
}

.innovation svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.innovation .innovation-text {
  position: relative;
  width: 574px;
  margin: 0;
}

.partners {
  text-align: center;
  margin: 68px 0;
}

.partners h2 {
  color: #880F50;
}

.partners .section-description {
  width: 842px;
}

.partners .section-description p {
  margin-bottom: 45px;
}

.partners .partners-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 68px;
}

.partners .partners-list .partner {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 256px;
  padding: 4% 0;
  margin: 0 8px;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0,0,0,.06);
}

.partners .partners-list .partner img {
  display: block;
  width: 81.25%;
}

.partners .partners-list .partner i {
  font-size: 3.71em;
  color: #F7F7F7;
}

.partners .partners-list .partner .link {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  color: #880F50;
  font-size: .72em;
  letter-spacing: .58em;
  text-transform: uppercase;
  line-height: 1;
  opacity: 0;
  transition: all .16s ease-out;
  padding-top: 20px;
  transform: translateY(-20px);
}

@media screen and (min-width: 1025px) {
  .partners .partners-list .partner:hover .link {
    opacity: 1;
    transform: translateY(0);
  }
}

.partners .partners-list .partner .link .ic {
  width: 10px;
  height: 10px;
}

@media screen and (max-width: 1024px) {
  .banner {
    min-height: 0;
  }
  .banner .wrapper {
    padding-top: 0;
    width: auto;
    max-width: none;
  }
  .banner .introduction {
    position: relative;
    padding: 30vh 24px 0;
    width: auto;
    top: auto;
    left: auto;
    height: 78vh;
    background: url(../assets/cast_m_home_banner@2x.png) no-repeat center bottom/cover;
    text-shadow: 1px 1px rgba(0,0,0,.23)
  }
  .banner .introduction[data-v-fae5bece]:before {
    display: none;
  }
  .banner .introduction h1 {
    font-size: 32px;
    width: 355px;
    margin: 0 auto 12px;
  }
  .banner .introduction p {
    font-size: 18px;
    margin: auto;
  }
  .banner-background,
  .banner .follow .follow-image {
    display: none;
  }
  .banner .wrapper:before {
    bottom: 15vh;
    z-index: 1;
    left: auto;
    right: 48%;
    width: 184px;
    height: 144px;
  }
  .banner .next-event {
    width: 268px;
    height: 74px;
    padding: 14px 28px;
    margin: auto;
    left: 96px;
    right: 0;
    bottom: 17vh;
    padding-right: 48px;
  }
  .banner .next-event > i {
    position: absolute;
    right: 16px;
    top: 28px;
  }
  .banner .next-event .event-date .month .date-format {
    display: none;
  }
  .banner .next-event > div > span {
    font-size: 8px;
  }
  .banner .next-event .event-date {
    font-size: 11px;
  }
  .banner .next-event .event-date .month .mobile {
    display: block;
    font-size: 11px;
  }
  .banner .next-event > div > span > .date-format {
    margin-left: -4px;
    font-size: 14px;
  }
  .banner .next-event .event-location {
    margin-top: 4px;
    line-height: 1.25;
  }
  .banner .follow .socials {
    bottom: 20px;
    left: 0;
    text-align: center;
  }
  .banner .follow .socials a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(0, 162, 237, 0.5);
    font-size: 20px;
    margin: 0 6px;
  }
  .banner .follow .socials a i {
    margin-left: 8px;
  }
  .banner .follow .socials div {
    font-size: 10px;
    margin-top: 8px;
  }
  .creative {
    margin: 0;
    background: url(../assets/cast_m_home_register.svg) no-repeat center bottom/auto;
  }
  .creative > .wrapper {
    padding-bottom: 80px;
  }
  section h2 {
    text-align: center;
    font-size: 28px;
  }
  .creative h2 {
    margin-bottom: 248px;
  }
  .section-description {
    width: auto;
  }
  .section-description p {
    margin-bottom: 34px;
    font-size: 18px;
    line-height: 1.77;
  }
  section h2:after {
    margin: 16px auto 0;
  }
  .creative svg {
    bottom: auto;
    top: 8px;
    height: 288px;
  }
  .creative .creative-text {
    position: absolute;
    width: 276px;
    top: 132px;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 19px;
    padding: 0;
  }
  .section-description > .btn {
    display: flex;
    width: 168px;
    margin: auto;
  }
  .news {
    margin-top: 16px;
  }
  .news .btn {
    margin-top: 36px;
  }
  .news .wrapper {
    width: auto;
    max-width: none;
  }
  .events {
    background: none;
    margin-top: 72px;
    padding-top: 0;
  }
  .events .title-line {
    flex-flow: column nowrap;
  }
  .events .title-line .subtitle {
    width: 278px;
    margin: auto;
    line-height: 2.2;
  }
  .events .title-line h2:after {
    display: block;
    margin: 14px auto;
  }
  .events .posts-mobile {
    margin-top: 16px;
  }
  .events .wrapper {
    margin: 0;
  }
  .events .btn-ic {
    margin: 36px auto auto;
  }
  .innovation {
    margin-top: 56px;
    height: 332px;
    background: url(../assets/cast_m_home_innovation@2x.png) no-repeat center/366px auto;
  }
  .innovation svg {
    display: none;
  }
  .innovation .innovation-text {
    width: 255px;
    font-size: 20px;
  }
  .partners {
    margin-top: 52px;
  }
  .partners .partners-list {
    margin: 0 -24px;
  }
  .partners .partners-list .partner {
    width: auto;
    height: 100%;
    margin: 0;
    padding: 19% 0;
  }
  .partners .swiper-container >>> .swiper-slide {
    padding-bottom: 32px;
  }
  .partners .btn {
    margin-top: 24px;
  }
  .partners .partners-list .partner .link {
    top: auto;
    bottom: 12px;
    opacity: 1;
  }
  .partners .partners-list .partner .link i {
    vertical-align: baseline;
  }
}

@media screen and (max-width: 410px) {
  .banner .introduction h1 {
    font-size: 24px;
  }
  .banner .introduction p {
    font-size: 16px;
  }
  .banner .introduction h1 b {
    display: block;
  }
  .banner .next-event {
    margin: 0;
  }
}
</style>
